import { j as e } from "./atoms-v218.js";
import { forwardRef as x } from "react";
import { Policy as n, Header as f, Title as d, Content as g, PolicyItem as j, PolicyIcon as u, TextContent as p } from "./atoms-v21032.js";
import { Column as h } from "./atoms-v212.js";
import { useBreakpoints as L } from "./atoms-v251.js";
const P = x(
  ({ className: s, id: i, primaryContent: o, title: l }, c) => {
    const { current: m } = L(), a = () => m === "max" ? "medium" : "small";
    return /* @__PURE__ */ e.jsxs(n, { className: s, id: i, ref: c, tagName: "article", children: [
      /* @__PURE__ */ e.jsx(f, { large: 8, offset: { xLarge: 1 }, xLarge: 14 }),
      /* @__PURE__ */ e.jsx(h, { large: 3, max: 5, medium: 8, offset: { xLarge: 1 }, small: 4, xLarge: 6, children: /* @__PURE__ */ e.jsx(d, { children: l }) }),
      /* @__PURE__ */ e.jsx(g, { large: 5, max: 8, medium: 8, offset: { xLarge: 1 }, small: 4, xLarge: 7, children: o == null ? void 0 : o.map((r, t) => /* @__PURE__ */ e.jsxs(j, { children: [
        /* @__PURE__ */ e.jsx(u, { name: r.icon, size: a() }),
        /* @__PURE__ */ e.jsx(p, { children: r.content })
      ] }, `booking-policy-item-${r.icon}-${t}`)) })
    ] });
  }
);
P.displayName = "Blocks.Policy";
export {
  P as Policy
};
